import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MessagingStatLog, MessagingType } from '../models/MessagingStatLog';


@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  constructor(public http: HttpClient) 
  {

  }

  public fetchEmailErrorLogs() {
    return this.http.get(environment.baseURl + '/api/messaging/errors');
  }

  public fetchEmailErrorLogsSingleReport(reportId: number) {
    return this.http.get(environment.baseURl + `/api/messaging/errors/${reportId}`);
  }

  public resolveEmailError(error: MessagingStatLog) {
    return this.http.post(environment.baseURl + '/api/messaging/errors/', error);
  }

  public sendEmailPacket(stat: MessagingStatLog) {
    return this.http.post(environment.baseURl + '/api/messaging/errors/send', stat);
  }
}
